export const FACTION_VALUES = {
  AX: {
    reference: 'AX',
    icon: 'fa-kit fa-custom fa-ax',
  },
  BR: {
    reference: 'BR',
    icon: 'fa-kit fa-custom fa-br',
  },
  LY: {
    reference: 'LY',
    icon: 'fa-kit fa-custom fa-ly',
  },
  MU: {
    reference: 'MU',
    icon: 'fa-kit fa-custom fa-mu',
  },
  OR: {
    reference: 'OR',
    icon: 'fa-kit fa-custom fa-or',
  },
  YZ: {
    reference: 'YZ',
    icon: 'fa-kit fa-custom fa-yz',
  },
};
